import { CoreApiClient } from "@stellar/core-api-client";
import { sentryCaptureError } from "@utils/sentry-utils";
import { runtimeConfig } from "@src/runtime-config";

/** Returns FaroCoreApiClient created from the provided api url */
export function getFaroCoreApiClient(apiUrl: string): CoreApiClient {
  return new CoreApiClient({
    baseUrl: apiUrl,
    headers: {
      // eslint-disable-next-line @typescript-eslint/naming-convention -- this key is defined by the backend
      "X-Holobuilder-Component": "sphereEntryPage",
    },
    // If the return type is different than what we expected, we log an assertion error.
    onLogAssertion: ({ message, error, routeName }) => {
      const title = `CoreApiClient assertion error in route ${routeName}.`;
      // Capture the error with Sentry. The title has the route name making it easy to find.
      // The error shows the message from Zod as it is human readable
      sentryCaptureError({
        title,
        error: message,
        isAssertionError: true,
      });

      // eslint-disable-next-line no-console
      console.error(title, message, error.issues);
    },
  });
}

/**
 * This is the new Core API client that is used to communicate with the Core API repo.
 * It is used to fetch data from the Core API and to send data to the Core API.
 */
export const faroCoreApiClient = getFaroCoreApiClient(
  runtimeConfig.urls.apiBaseUrl
);
